import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=35ad14e9&"
import script from "./ImageUpload.vue?vue&type=script&lang=js&"
export * from "./ImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ImageUpload.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ad14e9')) {
      api.createRecord('35ad14e9', component.options)
    } else {
      api.reload('35ad14e9', component.options)
    }
    module.hot.accept("./ImageUpload.vue?vue&type=template&id=35ad14e9&", function () {
      api.rerender('35ad14e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EHR-Lite/ImageUpload.vue"
export default component.exports